import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SendAgainLink = ({
  initialTime = 120,
  onClick,
  disabled = false,
  label,
}) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isCounting, setIsCounting] = useState(true);

  const { t } = useTranslation();

  useEffect(() => {
    let timer;
    if (isCounting && timeLeft > 0) {
      timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
      setTimeLeft(initialTime);
    }

    return () => clearTimeout(timer);
  }, [timeLeft, isCounting, initialTime]);

  const handleClick = () => {
    if (disabled || isCounting) return;
    onClick?.();
    setIsCounting(true);
  };

  return (
    <span
      onClick={handleClick}
      className={`
        ${
          isCounting
            ? "text-gray-800 no-underline cursor-not-allowed"
            : "text-vestelColor underline cursor-pointer"
        }
        transition-colors font-league-semibold text-sm
      `}
    >
      {isCounting
        ? `${label} (${timeLeft} ${t("heplers.second")})`
        : `${label}`}
    </span>
  );
};

export default SendAgainLink;
